<script setup lang="ts">
import { useObjectGeoJson } from '../model/model.ts'
import type { PropType } from 'vue'

defineProps({
  item: {
    type: Object as PropType<{ id: number; object_type: { id: number } }>,
    required: true,
  },
})

const { downLoadFile, isFetching: isDownloading } = useObjectGeoJson()
</script>

<template>
  <VBtn
    color="warning"
    density="compact"
    class="hide_mobile"
    :loading="isDownloading"
    @click="downLoadFile(item.object_type.id, [item.id])"
  >
    Выгр. коорд.
  </VBtn>
</template>
